"use strict";

exports.__esModule = true;
exports.mergeFilteredTree = exports.getFlattenTree = exports.getFilterTree = void 0;

var _immer = _interopRequireDefault(require("immer"));

var _clone = require("./clone");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFilterTree = function getFilterTree(treeNodes, filterFunc, filterExpandKeys, keyFunc, childrenKey, showHitDescendants, firstMatchNode, _ref) {
  if (childrenKey === void 0) {
    childrenKey = 'children';
  }

  var advanced = _ref.advanced;

  var mapFilteredNodeToData = function mapFilteredNodeToData(node) {
    if (!node) return null;
    var match = false;

    if (filterFunc(node)) {
      if (firstMatchNode) firstMatchNode(node);
      match = true;
    }

    var children = (node[childrenKey] || []).map(mapFilteredNodeToData).filter(function (n) {
      return n;
    });

    if (children.length || match) {
      var _objectSpread2;

      var key = keyFunc(node);
      if (filterExpandKeys && children.length > 0) filterExpandKeys.push(key);
      if (!node[childrenKey]) return node;
      var childNodes = showHitDescendants && match ? node[childrenKey] || [] : children;
      if (advanced && match && children.length > 0) childNodes = children;
      return _objectSpread({}, node, (_objectSpread2 = {}, _objectSpread2[childrenKey] = childNodes, _objectSpread2));
    }

    return null;
  };

  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
    return node;
  });
};

exports.getFilterTree = getFilterTree;

var getFlattenTree = function getFlattenTree(data, childrenKey) {
  if (childrenKey === void 0) {
    childrenKey = 'children';
  }

  var arr = [];
  var path = [];

  var flatten = function flatten(list) {
    list.forEach(function (item) {
      var children = item[childrenKey];

      if (children && children.length > 0) {
        path.push(item);
        flatten(children);
      } else {
        arr.push([].concat(path, [item]));
      }
    });
    path = [];
  };

  flatten(data);
  return arr;
};

exports.getFlattenTree = getFlattenTree;

var mergeFilteredTree = function mergeFilteredTree(filterDatum, rawDatum, tiledId) {
  var filterData = filterDatum.data;
  var childrenKey = filterDatum.childrenKey;
  if (tiledId.length === 0) return filterData;

  var recursion = function recursion(node) {
    var nodeKey = filterDatum.getKey(node);

    if (tiledId.indexOf(nodeKey) >= 0) {
      node[childrenKey] = (0, _clone.deepClone)(rawDatum.getDataById(nodeKey)[childrenKey] || []);
    } else {
      var item = filterDatum.getDataById(nodeKey);

      if (item && item[childrenKey]) {
        node[childrenKey] = (0, _clone.deepClone)(item[childrenKey] || []);
      }
    }

    var children = node[childrenKey] || [];
    children.map(recursion);
  };

  return (0, _immer.default)(filterData, function (draft) {
    draft.map(recursion);
  });
};

exports.mergeFilteredTree = mergeFilteredTree;